import React, { useState, useEffect } from 'react';
import DateTimeField from 'react-datetime';
import moment from 'moment-timezone';
import './DateTimePicker.scss';

// All library props (react-datetime) can be found at: https://github.com/YouCanBookMe/react-datetime
export const DateTimePicker = (props: any) => {
    const { label, error, value, onChange, dateOnly } = props;
    moment.tz.setDefault();

    const getInitialMoment = () => {
        if (value == null || value === '') return moment();
        const m = moment(value);
        return m.isValid() ? m : moment();
    };
    const [dateTime, setDateTime] = useState(getInitialMoment);

    const valueKey = value != null && typeof value === 'object' && 'valueOf' in value ? (value as { valueOf(): number }).valueOf() : value;
    useEffect(() => {
        if (value == null || value === '') return;
        const m = moment(value);
        if (m.isValid()) setDateTime(m);
    }, [valueKey]);

    const updateStateOnChange = (newValue: any): void => {
        const parsed = moment(newValue, 'M/D/YYYY', true);
        const momentDate = parsed.isValid() ? moment(newValue) : moment(newValue);
        const toStore = moment.isMoment(momentDate) && momentDate.isValid() ? momentDate : moment(momentDate).isValid() ? moment(momentDate) : moment();
        setDateTime(toStore);
        onChange(toStore);
    };
    const DateRender:any = () =>{
        if(value == '') {
           
        return (    <DateTimeField
            {...props}
            
            onChange={updateStateOnChange}
            dateFormat="MM/DD/YYYY"
            timeFormat={dateOnly ? false : 'h:mm A'}
            inputProps={{placeholder:'MM/DD/YYYY'}}
            renderInput={(props) => {
                return <input {...props} value={(value) ? props.value : ''} />
            }}
        /> )
        } else {
            
            return (   
            <DateTimeField
            {...props}
            value={value ? dateTime : ''}
            onChange={updateStateOnChange}
            dateFormat="MM/DD/YYYY"
            timeFormat={dateOnly ? false : 'h:mm A'}
            inputProps={{placeholder:'MM/DD/YYYY'}}
            renderInput={(props) => {
                return <input {...props}   />
            }}
        /> )
        }
    }

    return (
        <span className={`${error ? 'DateTimePicker-Container-Error' : 'DateTimePicker-Container'}`}>
            {label && (
                <span className={`${error ? 'DateTimePicker-Label-Error' : 'DateTimePicker-Label'}`}>{label}</span>
            )}
          {DateRender()}
            <span className="DateTimePicker-Error">{error}</span>
        </span>
    );
};

export default DateTimePicker;
